module.exports = __webpack_public_path__ + "img/product-icon.443f9343.svg";